module.exports = __webpack_public_path__ + "img/f6-2-5.36c6a788.png";